module.exports = __webpack_public_path__ + "static/media/Sizing_for_Life.6bd66e57.png";